import React from 'react';
import { I18n } from '@fiverr-private/i18n-react';
import { HighlightedRecommendations } from '../HighlightedRecommendations/HighlightedRecommendations';
import { type RecommendationsProps } from '../Recommendations.types';
import { TROPHY_GIF_PATH, SOURCE_COMPONENT } from './RepeatedBuyers.constants';
import './styles.scss';

const BASE_KEY = 'search_perseus.recommendations.repeat_buyers';

export const RepeatedBuyersRecommendations: React.FC<RecommendationsProps> = ({
    listings,
    gigs = [],
    isLoading = false,
    isNarrowView = false,
}) => (
    <HighlightedRecommendations
        className="repeated-buyers-recommendations"
        title={<I18n k={`${BASE_KEY}.title`} />}
        description={<I18n k={`${BASE_KEY}.description`} />}
        listings={listings}
        gigs={gigs}
        componentName={SOURCE_COMPONENT}
        iconPath={TROPHY_GIF_PATH}
        isLoading={isLoading}
        isNarrowView={isNarrowView}
    />
);
